import { useForm } from 'react-hook-form';
import { useBarcodeQuery } from './useGetBarcodeQuery';

export const useGetRegisterList = (warrantyNumberCode) => {
  const { control, getValues, setValue, reset } = useForm();

  const { mutate: onCallBarcode, loading: isLoadingBarcode } = useBarcodeQuery({
    reset,
    getValues,
    setValue,
  });

  const handleOnEnterBarcode = (barcode) => {
    onCallBarcode({ warrantyNumberCode, barcode });
  };

  return {
    control,
    getValues,
    setValue,
    handleOnEnterBarcode,
    isLoadingBarcode,
  };
};
